import { PrimaryButton } from '@photosi/rn-components/buttons/primary-button/PrimaryButton';
import { TextIconButton } from '@photosi/rn-components/buttons/text-icon-button/TextIconButton';
import {
  TEXT_ICON_BUTTON_SIZES,
  TEXT_ICON_BUTTON_TYPES,
} from '@photosi/rn-components/buttons/text-icon-button/TextIconButton.constants';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import { modalTestID } from 'src/helpers/testIDs.helper';

import { UploadScreenChildProps } from '../UploadScreen.types';

export type UploadedComponentProps = UploadScreenChildProps;

export const UploadedComponent = ({
  onPressUpload,
  onPressRedirectToPhotosiCta,
  illustrationName,
  title,
  description,
  ctaText,
  redirectText,
  redirectCtaText,
  style,
}: UploadedComponentProps) => {
  return (
    <View style={style.uploadedContent}>
      <View style={style.topContent}>
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={illustrationName} />
        </View>
        <View style={[style.textWrapper, { gap: 16, width: '100%' }]}>
          <TextLato style={style.title}>{title}</TextLato>
          <TextLato style={style.text}>{description}</TextLato>
        </View>
        <View>
          <PrimaryButton
            style={style.button}
            onPress={onPressUpload}
            testID={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
            focusId={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
            focusOrder={0}
            focusGroup={FocusGroups.CHOOSE_PHOTO_BANNER}
            text={ctaText}
            textStyle={style.buttonText}
          />
        </View>
      </View>
      {redirectText && redirectCtaText && onPressRedirectToPhotosiCta && (
        <View style={style.bottomContent}>
          <TextLato style={style.redirectText}>{redirectText}</TextLato>
          <TextIconButton
            innerStyle={style.redirectCta}
            onPress={onPressRedirectToPhotosiCta}
            testID={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
            focusId={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
            focusOrder={0}
            focusGroup={FocusGroups.CHOOSE_PHOTO_BANNER}
            text={redirectCtaText}
            textStyle={style.redirectCtaText}
            iconStyle={style.redirectCtaIcon}
            size={TEXT_ICON_BUTTON_SIZES.LARGE}
            type={TEXT_ICON_BUTTON_TYPES.ICON_RIGHT}
            iconName={ICON_NAMES.ArrowRight1}
          />
        </View>
      )}
    </View>
  );
};

